import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Chapter, Reveal, PHONE_DISPLAY } from "./booking";

const FAQS = [
  {
    q: "Do I need to book an appointment, or do you accept walk-ins?",
    a: "Both. Walk-ins are welcome when chairs are available, and appointments can be booked online anytime. Booking ahead is the best way to lock in your preferred time.",
  },
  {
    q: "What payment methods do you accept?",
    a: `Payment options can vary — ask our team at the shop or call ${PHONE_DISPLAY} for current payment information.`,
  },
  {
    q: "How much do haircuts cost?",
    a: "Current pricing is listed on our live online booking menu. Check the booking page or contact the shop for up-to-date service pricing.",
  },
  {
    q: "Do you offer kids' haircuts?",
    a: "Yes. Kids & Senior Cuts are part of our regular service menu, in a comfortable, welcoming environment.",
  },
  {
    q: "Do you offer discounts?",
    a: "We run weekly Community Days — Educator Mondays, Tuesdays for Our Troops, Wednesdays for Our First Responders, and Student Thursdays. Ask our team about today's special.",
  },
  {
    q: "What are your business hours?",
    a: `Hours can vary by day and barber. Check the live booking calendar for real-time availability or call ${PHONE_DISPLAY}.`,
  },
  {
    q: "Where is Faded Barber Co. located?",
    a: "6803 Backlick Rd # B, Springfield, VA 22150 — serving Springfield, Alexandria, and surrounding Northern Virginia communities.",
  },
  {
    q: "Can I book online?",
    a: "Yes. Book directly on this site through our Squire booking system, or through the Faded Barber Co. app on the App Store.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="px-5 lg:px-12 py-20 lg:py-32 border-t border-border">
      <Chapter index="06" title="FAQ" />
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
              Questions,
              <br />
              <span className="text-primary">answered.</span>
            </h2>
            <p className="mt-6 max-w-sm text-base text-muted-foreground font-light leading-relaxed">
              Everything you need to know before your first visit to our Springfield, VA
              barbershop.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} className="border-border">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="text-left font-semibold text-base sm:text-lg hover:text-primary hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${i}`}
                    className="text-muted-foreground font-light leading-relaxed text-sm sm:text-base"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
